<template>
    <h1 class="country__details-title">Fylker med mest plukking totalt</h1>
    <div class="country__details-subtitle">Inkluderer også registreringer fra anonyme brukere.</div>
    <ul class="country__details" :class="{ 'country__details--loading': loading }">
        <li v-if="loading" class="country__details-item--loading">
            <span class="country__details-spinner"></span>
        </li>
        <template v-else>
            <li class="country__details-item"
                v-for="item of sortedTopFiveItems"
                v-bind:key="item"
                @mouseenter="onItemHover(item)"
                @mouseleave="onItemLeave"
            >
                <span class="country__details-icon" :style="getIconStyle(item)"></span>
                <span class="country__details-text">
                    <span class="country__details-text-berry-type">{{ item.name }}: </span>
                    <span class="country__details-text-amount">{{ item.county ? item.county.name : '' }} {{ formatAmount(item.amount) }} {{ item.uom.name }}</span>
                </span>
            </li>
        </template>
    </ul>
</template>
<script>
    import { getIconStyle } from './items.js';
    export default {
        emits: ['highlight-county', 'clear-highlight'],
        props: ['topFiveItems', 'activeGroup', 'loading'],
        setup() {
            return { getIconStyle };
        },
        computed: {
            sortedTopFiveItems() {
                return [...this.topFiveItems].sort((a, b) => a.name.localeCompare(b.name, 'no'));
            },
        },
        methods: {
            onItemHover(item) {
                if (item.county) {
                    this.$emit('highlight-county', item.county.id);
                }
            },
            onItemLeave() {
                this.$emit('clear-highlight');
            },
            formatAmount(amount) {
                return amount % 1 ? amount.toFixed(1) : amount;
            }
        }
    }
</script>
